// extracted by mini-css-extract-plugin
module.exports = {"regionOverviewDescription":"RegionOverview_regionOverviewDescription__vFlfl"};